import React, { useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom';
import './BreadcrumbBlock.scss'
import { IPagination } from '../../pages/Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { NodeEvent } from '../../pages/Customers/CustomerGroup/Component/SideBar';

interface Props {

  items: Array<any>;
  backLink?: string;
  historyBack?: any;
  description?: string;
  className?: string;

  //restore
  firstPage?: string
  inforNodeEvent?: NodeEvent
  restorePagination?: IPagination
  restoreDataFilterList?: any
}

const BreadcrumbBlockAdd: React.FC<Props> = ({
  items, backLink, description,
  className = '', historyBack = '',
  firstPage, inforNodeEvent,
  restorePagination, restoreDataFilterList
}) => {
  const navigate = useNavigate()
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);
  const goBack = () => {
    if (typeof window !== 'undefined' && window.history && window.history.length > 1) {
      return navigate(-1);
    }
    return navigate(historyBack);
  }
  return (
    <div className={`app-breadcrumb-block ${className}`}>
      <Breadcrumb
        items={items}
      />

     
    </div >
  );
}

export default BreadcrumbBlockAdd;
